import { baseAPIRequest } from 'utilities/http';

const getZipCodeByLocation = async (latitude, longitude) => {

	try {

		const response = await baseAPIRequest({
			url: '/api/regions/zip/',
			data: {
				latitude,
				longitude
			},
			params: {
				method: 'GET'
			},
			errorStatusHandlers: {},
			abortController: {},
			timer: 0
		});

		return response?.Zipcode || '';

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error('Error getting zip code from lat/long:', error);

	}

	return '';

};

export default getZipCodeByLocation;
